<div class="hol-addons-panel" [class.deployed]="expanded">
  <ng-content> </ng-content>
</div>
